import React from 'react';
import { type StyleProp, type TextStyle, type ViewStyle, Text, View } from 'react-native';
import styles from './styles';

// from mobile

export type ItemSeparatorComponentProps = {
  expanded?: boolean;
  style?: StyleProp<ViewStyle>;
  containerStyle?: StyleProp<ViewStyle>;
  titleStyle?: StyleProp<TextStyle>;
  title?: string;
};

const ItemSeparatorComponent: React.FC<ItemSeparatorComponentProps> = ({
  title,
  style,
  expanded,
  titleStyle,
  containerStyle,
}) => (
  <View style={[styles.row, expanded && styles.margin, containerStyle]}>
    {title && (
      <>
        <View style={[styles.border, style]} />
        <Text style={[styles.title, titleStyle]}>{title}</Text>
      </>
    )}
    <View style={[styles.border, style]} />
  </View>
);

export default ItemSeparatorComponent;
